import { Modal } from "components";
import type { ModalProps } from "components/Modal";
import type { ReactStoryblokComponent } from "types/storyblok";

export const ModalAdapter = ({
  blok: { buttonSize, buttonText, buttonVariant, content, modalSize },
  sbEditable,
}: ReactStoryblokComponent<ModalProps>) => (
  <Modal
    buttonSize={buttonSize}
    buttonText={buttonText}
    buttonVariant={buttonVariant}
    content={content}
    modalSize={modalSize}
    sbEditable={sbEditable}
  />
);
